import type { Client, ClientHeaders } from "@medusajs/js-sdk";

import type { SalonStockerHttpTypes } from "../types";

export class SellerOffer {
  /**
   * @ignore
   */
  private client: Client;
  /**
   * @ignore
   */
  constructor(client: Client) {
    this.client = client;
  }

  /**
   * This method is used to retrieve a seller's offer by its ID. It sends a request to the
   * `/store/offer/{id}` API route.
   *
   * @param id - The offer's ID.
   * @param query - Configure the fields to retrieve.
   * @param headers - Headers to pass in the request
   * @returns The product.
   */
  retrieve = async (
    id: string,
    query?: SalonStockerHttpTypes.StoreSellerOfferParams,
    headers?: ClientHeaders
  ): Promise<SalonStockerHttpTypes.StoreSellerOfferResponse> => {
    return await this.client.fetch<SalonStockerHttpTypes.StoreSellerOfferResponse>(
      `/store/offer/${id}`,
      {
        method: "GET",
        query,
        headers
      }
    );
  };
}
